<template>
    <be-form-group v-bind="widgetProps">
        <croppa
            ref="croppa"
            :width="width"
            :height="height"
            placeholder="Bild wählen"
            :placeholder-font-size="14"
            placeholder-color="#404040"
            accept="image/*"
            :file-size-limit="maxSize"
            :quality="2"
            :zoom-speed="4"
            :disabled="disabled"
            :prevent-white-space="!whitespace"
            show-remove-button
            :remove-button-size="15"
            remove-button-color="#ea4335"
            :initial-image="value"
            initial-size="contain"
            initial-position="center"
            :fillPlaceholderImage="true"
            show-loading

            @image-remove="$emit('input', null)"
        ></croppa>
    </be-form-group>
</template>

<script>
    import widget from '../../mixins/widget';
    import errorHandler from '../../mixins/errorHandler';

    export default {
        mixins: [widget, errorHandler],

        props: {
            width: {
                type: Number,
                default: 200,
            },
            height: {
                type: Number,
                default: 200,
            },
            maxSize: {
                type: Number,
                default: 0,
            },
            whitespace: {
                type: Boolean,
                default: false,
            },
        },

        methods: {
            async upload() {
                const file = this.$refs.croppa.getChosenFile();

                if (!file) {
                    return;
                }

                const blob = await this.$refs.croppa.promisedBlob();

                try {
                    const form = new FormData();
                    form.append('filedata', blob, file.name);
                    const response = await this.$http.post('images/sourceimages', form);

                    if (response.body.error) {
                        throw response;
                    }

                    this.$emit('input', response.body.items[0].hash);
                } catch (response) {
                    this.catchError(
                        'Fehler beim Upload',
                        `Die Datei "${file.name}" konnte nicht hochgeladen werden.`,
                        response,
                    );
                }
            },

            refresh() {
                this.$refs.croppa.refresh();
            },
        },

        watch: {
            value() {
                this.$refs.croppa.refresh();
            },
        },
    };
</script>

<style lang="scss">
    .croppa-container {
        canvas {
            border: 1px solid #d5d8de;
            border-top-color: #bdc0c7;
        }
    }
</style>
